import {Dayjs} from "@dracul/dayjs-frontend";

export default {
    computed:{
        shortAddress() {
            return (address) => {
                return address.split(",")[0];
            };
        },
        getRangeScheduleTime() {
            return this.$store.getters.getSettingValue("RangeScheduleTime");
        },
        getTime() {
            return (order) => {
                if (order.delivery.mode === "DELIVERY" && order.delivery.time) {
                    let hour = Dayjs(order.delivery.time, "HH:mm");
                    let text;
                    if (order.delivery.timeMode === "AS_SON_AS_POSIBLE") {
                        text = hour.format("HH:mm");
                    } else {
                        let hourTo = hour.add(this.getRangeScheduleTime, "m");
                        text = hour.format("HH:mm") + "-" + hourTo.format("HH:mm");
                    }

                    return text;
                } else {
                    return order.delivery.time;
                }
            };
        },
        getAlarmColor() {
            return (hour, date) => {
                let now = Dayjs();
                if(Dayjs(date).isAfter(now.endOf("day"))) {
                    return "purple lighten-4 purple--text text--darken-4";
                }

                let dhour = Dayjs(hour, "HH:mm");

                let dangerHour = now.add(10, "minute");
                if (dangerHour.isAfter(dhour)) {
                    return "red lighten-4 red--text text--darken-4";
                }

                let warnHour = now.add(25, "m");
                if (warnHour.isAfter(dhour)) {
                    return "yellow lighten-4 yellow--text text--darken-4";
                }

                return "green lighten-4 green--text text--darken-4";
            };
        },
        getMaxKmForMinCost() {
            return this.$store.getters.getSettingValue("maxKmForMinCost");
        },
        orderMode() {
            return (order) => {
                if (order.delivery.onBar && order.delivery.mode === "TAKE_AWAY") {
                    return "M";
                } else if (
                    !order.delivery.onBar &&
                    order.delivery.mode === "TAKE_AWAY"
                ) {
                    return "T";
                } else if (order.delivery.mode === "SALON") {
                    return "S";
                } else {
                    return "D";
                }
            };
        },
        orderModeColor() {
            return (order) => {
                if (this.orderMode(order) === "M") {
                    return "orange  orange--text text--darken-4";
                } else if (this.orderMode(order) === "T") {
                    return "purple  green--text text--darken-4";
                }
                else if (this.orderMode(order) === "S") {
                    return "green  green--text text--darken-4";
                }
                else {
                    return "blue  blue--text text--darken-4";
                }
            };
        },
    },
    methods:{

    }

}
